import {
  dedupeOrganizationTypeValues,
  fetchAllOrganizationTypes,
  mapOrganizationTypeValues,
} from './organization-type-options.shared';
import { OnOptionsLoad } from './types';

/** Synthetic autocomplete value; stripped before API requests. */
export const ALL_HEALTHCARE_ORGANIZATION_TYPE_ID = -2;

export const ALL_HEALTHCARE_ORGANIZATION_TYPE_OPTION: {
  id: number;
  name: string;
} = {
  id: ALL_HEALTHCARE_ORGANIZATION_TYPE_ID,
  name: 'All Healthcare',
};

/** Organization type names included when "All Healthcare" is selected. */
export const HEALTHCARE_ORGANIZATION_TYPE_NAMES = [
  'Hospital',
  'Medical sexual abuse',
  'Therapy/Counseling',
] as const;

const normalizedHealthcareNames = new Set(
  HEALTHCARE_ORGANIZATION_TYPE_NAMES.map((name) => name.trim().toLowerCase()),
);

export const isAllHealthcareOrganizationTypeOption = (
  item: { id?: number | string } | null | undefined,
): boolean => Number(item?.id) === ALL_HEALTHCARE_ORGANIZATION_TYPE_ID;

export const isHealthcareOrganizationTypeName = (
  name: string | undefined,
): boolean => {
  if (!name) {
    return false;
  }

  return normalizedHealthcareNames.has(name.trim().toLowerCase());
};

export async function loadHealthcareOrganizationTypes(
  onOptionsLoad: OnOptionsLoad,
): Promise<Array<{ id: number; name: string }>> {
  const allOrgTypes = await fetchAllOrganizationTypes(onOptionsLoad);

  return mapOrganizationTypeValues(
    allOrgTypes.filter((orgType) =>
      isHealthcareOrganizationTypeName(orgType.name),
    ),
  );
}

export async function resolveAllHealthcareOrganizationTypes(
  onOptionsLoad: OnOptionsLoad,
  currentValue: Array<{ id: number; name: string }> | undefined,
): Promise<Array<{ id: number; name: string }>> {
  const healthcareTypes = await loadHealthcareOrganizationTypes(onOptionsLoad);

  const withoutAllHealthcare = (currentValue ?? [])
    .filter((item) => !isAllHealthcareOrganizationTypeOption(item))
    .map((item) => ({
      id: typeof item.id === 'number' ? item.id : Number(item.id),
      name: item.name ?? '',
    }));

  return dedupeOrganizationTypeValues([
    ...withoutAllHealthcare,
    ...healthcareTypes,
  ]);
}
